import { apiService } from "@/common/api.service.js";

export default {
  // Site plans list
  getAllSitePlans() {
    const endpoint = `/api/site-plan-all/`;
    return apiService(endpoint);
  },

  // Site plan details
  sitePlanData(planId) {
    const endpoint = `/api/site-plans/${planId}/`;
    return apiService(endpoint);
  },

  // Site plan operations
  sitePlanCreate(payload) {
    const endpoint = `/api/site-plan-create/`;
    return apiService(endpoint, "POST", payload);
  },

  sitePlanUpdate(payload) {
    const endpoint = `/api/site-plan-update/${payload.id}/`;
    return apiService(endpoint, "PATCH", payload);
  },

  sitePlanCopy(payload) {
    const endpoint = `/api/site-plan-copy/`;
    return apiService(endpoint, "POST", payload);
  },

  updatePlanDates(payload) {
    const endpoint = `/api/update-dates/${payload.id}/`;
    return apiService(endpoint, "POST", payload);
  },

  createOpportunityPlanRelation(payload) {
    const endpoint = `/api/opportunity-plan-create/${payload.id}/`;
    return apiService(endpoint, "POST", payload);
  },

  planReorder(payload) {
    const endpoint = `/api/plan-reorder/${payload.id}/`;
    return apiService(endpoint, "POST", payload);
  },

  // Carbon tracker
  sitePlanCarbonTracker(payload) {
    const endpoint = `/api/site-plan-carbon-tracker/${payload.id}/`;
    return apiService(endpoint);
  },

  sitePlanCarbonTrackerUpdate(payload) {
    const endpoint = `/api/site-plan-carbon-tracker/${payload.id}/`;
    return apiService(endpoint, "POST", payload);
  },
};
